import React from 'react';
import SlideShow from 'react-image-show';

//Image carousel shown in mobile and desktop views and rendered withing 
//product detail component. This makes use of external carousel lib
const Carousel = (props) => {
    const bigImage = props.images.map((image) => {
        return (image.Src1130) ? image.Src1130 : image.src1130;
    });

    return (
        <div className='carousel'>
            <SlideShow
                images={bigImage}
                imagesHeightMobile="375px"
                indicators 
            />
        </div>
    )
}

export default Carousel;


// WEBPACK FOOTER //
// ./src/components/image-carousel.js